import type {
  FetchChatHistoryPayload,
  FetchChatHistoryResponse,
  GetStatusDataPayload,
  GetStatusDataResponse,
  ReportParticipantPayload,
} from "~/repository/chat.types";
import type { Sticker } from "~/types";

export async function getStatusData(
  payload: GetStatusDataPayload,
): Promise<GetStatusDataResponse> {
  const { videoId } = payload;
  const { $api } = useNuxtApp();
  return await $api("chat")(`video/${videoId}/setting`);
}

export async function fetchChatHistory(
  payload: FetchChatHistoryPayload,
): Promise<FetchChatHistoryResponse> {
  const { videoId } = payload;
  const { $api } = useNuxtApp();
  return await $api("chat")(`video/${videoId}/messages/latest`);
}

export async function fetchStickers(): Promise<Sticker[]> {
  const { $api } = useNuxtApp();
  return await $api("chat")(`stickers`);
}

export async function reportParticipant(
  payload: ReportParticipantPayload,
): Promise<Sticker[]> {
  const { $api } = useNuxtApp();
  const { username, videoId, messageId } = payload;
  return await $api("chat")(
    `/video/${videoId}/participant/${username}/message/${messageId}/report`,
    {
      method: "POST",
      body: payload,
    },
  );
}
